<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/artist-VIP.jpg" alt=""></transition></div>                        
                  <div class="page-content content">
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Features & Amenities" h1="Artist VIP Activations" />
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">                      
                        <p class='large yellow'>Allegiant Stadium is equipped with multiple premium spaces that can be made available for both pre- and post-show artist VIP activations.</p>
                      </div>                    
                    </transition>
                  </div>                
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>
import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
export default {
  name: "TheStadium",
  components: { PageBottom, TitleContent },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.image img {
  object-position: center;
}
</style>